import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectizeComponent } from '../../../blocks';
import { ModifyAppointmentService } from '../../../outpatient/out-pat-appointment/out-pat-reservation/modify-appointment/modify-appointment.service';
import { getDateObj, getNgBsObj, OutpatientParms, UserSessionService } from '../../../shared';
import { CallData, Mark_Leads, TotalData } from '../../call-center-reservation';

@Component({
    selector: 'app-reservation-call-modify-appointment',
    templateUrl: './reservation-call-modify-appointment.component.html',
    styleUrls: ['./reservation-call-modify-appointment.component.css']
})

export class ReservationCallModifyAppointmentComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    selectedPatAppointment: any;
    listeningGuid: string = 'ModApp';
    docId: number;
    selectedDay: Date;
    outpatientParms = <OutpatientParms>{};
    callData: CallData = <CallData>{};

    currentOutPatParms: any;
    WeeksData: any[];

    constructor(
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _modifyAppointService: ModifyAppointmentService) {
    }

    ngOnInit() {
        this.getPatAppointment();
        this.setModifyParms();
        this.getSelectedService$();
    }
    getPatAppointment() {
        this.selectedPatAppointment = this._userSessionService.getModalKey('ReservationCallModifyAppointmentComponent')["inputs"];
    }

    setModifyParms() {
        this.docId = this.selectedPatAppointment.docId;
        this.outpatientParms.docCode = this.selectedPatAppointment.docId;
        this.outpatientParms.SpecialityId = this.selectedPatAppointment.specialityId
        this.selectedDay = getNgBsObj(this.selectedPatAppointment.reservationDate);
        this.outpatientParms.ResourceType = 100;
        this.getReservationTimeSlots();
    }

    getSelectedService$() {
        this._userSessionService.getModalKey$()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'ReservationCallModifyAppointmentComponent' && keys.inputs) {
                    this.selectedPatAppointment = keys.inputs;
                    this.setModifyParms();
                }
            });
    }
    getDate() {
        this.outpatientParms.docCode = this.docId;
        this.getReservationTimeSlots();
    }
    doctorClicked(item: any) {
        if (item) {
            if (!item.AutoEmited) {
                this.outpatientParms.docCode = item.code;
                this.getReservationTimeSlots();
            }
        }
    }
    getReservationTimeSlots() {
        this.outpatientParms.ReservationDate = getDateObj(this.selectedDay);
        this._userSessionService.setSessionKey('_outpatientParms' + this.listeningGuid, this.outpatientParms /*,false*/);
    }

    selectedCurrentSlot(selectedSlot: any) {
        if (selectedSlot) {
            selectedSlot.docId = this.outpatientParms.docCode;
            this.callData.expectedStartTime = selectedSlot.startTimeSlot;
            this.callData.expectedEndTime = selectedSlot.endTimeSlot;
        }
    }
    save() {
        let _date = getDateObj(this.selectedDay)
        let year = (_date).getFullYear();
        let month = (_date).getMonth()
        let day = (_date).getDate()
        let starthour = (new Date(this.callData.expectedStartTime)).getHours();
        let startmin = (new Date(this.callData.expectedStartTime)).getMinutes();
        let endhour = (new Date(this.callData.expectedEndTime)).getHours();
        let endtmin = (new Date(this.callData.expectedEndTime)).getMinutes();
        this.callData.specialization = this.selectedPatAppointment.specialization;
        this.callData.patCode = this.selectedPatAppointment.patCode;
        this.callData.docId = this.docId;
        if (this.callData.docId) {
            this.callData.entityType = 3;
        }
        this.callData.serial = this.selectedPatAppointment.serial;
        this.callData.expectedStartTime = (new Date(year, month, day, starthour, startmin));
        this.callData.expectedEndTime = (new Date(year, month, day, endhour, endtmin));
        let patientdata = <TotalData>{
            callMainData: null,
            therapeuticCards: {},
            callData: this.callData,
            mark_Leads: <Mark_Leads>{}
        };
        this._modifyAppointService.updatePatientAppointment(patientdata).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((result) => {
                if (result["returnFlag"]) {
                    this._userSessionService.closeModalKey('ReservationCallModifyAppointmentComponent', result);
                }
            });

    }


    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
